import { Routes } from '@angular/router';
import { AuthGuard } from '../../core/_guards/auth.guards';
import { ApplicationAccessGuard } from '../../core/_guards/application-access.guard';
import { DeveloperApplicationAdminsComponent } from './componets/pages/developer-application-admins/developer-application-admins.component';
import { DeveloperApplicationDetailsComponent } from './componets/pages/developer-application-details/developer-application-details.component';
import { DeveloperApplicationGroupsComponent } from './componets/pages/developer-application-groups/developer-application-groups.component';
import { DeveloperApplicationMenuComponent } from './componets/pages/developer-application-menu/developer-application-menu.component';
import { DeveloperApplicationUsersComponent } from './componets/pages/developer-application-users/developer-application-users.component';
import { DeveloperApplicationsComponent } from './componets/pages/developer-applications/developer-applications.component';
import { DeveloperComponent } from './developer.component';

export const developerRoutes: Routes = [
  {
    path: 'developer',
    component: DeveloperComponent,
    canActivate: [AuthGuard],
    canActivateChild: [ApplicationAccessGuard],
    data: {
      role: 'Developer',
    },
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'applications',
      },
      {
        path: 'applications',
        component: DeveloperApplicationsComponent,
      },
      {
        path: 'groups',
        component: DeveloperApplicationGroupsComponent,
      },
      {
        path: 'application-detail',
        component: DeveloperApplicationDetailsComponent,
      },
      {
        path: 'application-menu',
        component: DeveloperApplicationMenuComponent,
      },
      {
        path: 'admins',
        component: DeveloperApplicationAdminsComponent,
      },
      {
        path: 'users',
        component: DeveloperApplicationUsersComponent,
      },
    ],
  },
];
